import { render, staticRenderFns } from "./phoneTrueFalse.vue?vue&type=template&id=51a61fc9&scoped=true"
import script from "./phoneTrueFalse.vue?vue&type=script&lang=js"
export * from "./phoneTrueFalse.vue?vue&type=script&lang=js"
import style0 from "./phoneTrueFalse.vue?vue&type=style&index=0&id=51a61fc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a61fc9",
  null
  
)

export default component.exports